import OidcLoadingFallback from '@/components/OidcLoadingFallback';
import { initDirectusSession } from '@/features/api/directus';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const DirectusCallbackPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Le cookie de session a été posé par Directus avant la redirection.
    // On appelle refresh() pour activer la session dans le SDK.
    initDirectusSession().then(() => {
      const redirectTo = sessionStorage.getItem('directus_redirect_after') ?? '/';
      sessionStorage.removeItem('directus_redirect_after');
      navigate(redirectTo, { replace: true });
    });
  }, [navigate]);

  return <OidcLoadingFallback />;
};

export default DirectusCallbackPage;
